import styled from '@emotion/styled';
import { PlainLinkStyles } from '@styles/common';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TelLinkProps {
  phoneNumber: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const PlainLink = styled.a({
  ...PlainLinkStyles
});

/* *********************** *
 *    TelLinkComponent    *
 * *********************** */

export const TelLink = ({ phoneNumber }: TelLinkProps) => {
  return (
    <>
      <PlainLink href={`tel:${phoneNumber.replaceAll(' ', '')}`}>{phoneNumber}</PlainLink>
    </>
  );
};
